<template>
  <loader v-if="loading"></loader>
  <div v-else class="animated fadeIn pt-4">
    <section-header title="Informazioni di sistema">
    </section-header>
    <b-row>
      <template v-for="store in stores">
        <b-card
          class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4"
          :title="store.name"
          v-if="isStoreInteresting(store)">
          <apexchart
            type="donut"
            :options="getStoreChartOptions(store)"
            :series="getStoreChartSeries(store)">
          </apexchart>
        </b-card>
      </template>
    </b-row>
    <div class="mb-4 text-right">
      <b-button variant="primary" @click.prevent="info()">Aggiorna</b-button>
    </div>
  </div>
</template>
<script>
import BasePageMixin from 'vue-core/mixins/BasePageMixin';
import SystemService from 'app/services/SystemService';
import { number2fileSize } from 'core/utils';

export default {
  mixins: [ BasePageMixin ],

  created() {
    this.info();
  },

  data() {
    return {
      stores: [],
    };
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Sistema',
        }
      ];
    },
  },

  methods: {
    info() {
      const success = ({ statusCode, data }) => {
        console.log('INFO', data);
        this.stores = data;
        this.loading = false;
      };

      const error = this.handleError.bind(this);

      this.loading = true;
      SystemService.info()
          .then(success, error);
    },

    isStoreInteresting(store) {
      return !store.name.includes('docker')
          && !store.name.includes('tmpfs')
          && !store.name.includes('udev')
      ;
    },

    getStoreChartOptions(store) {
      return {
        tooltip: {
          enabled: false
        },
        labels: ['Utilizzato', 'Disponibile'],
        /*
        dataLabels: {
          formatter(percentage, options) {
            const index = options.seriesIndex;
            //console.log('options', options);
            // console.log('seriesIndex', options.seriesIndex);
            const label = options.w.config.labels[index];
            const value = options.w.config.series[index];
            console.log('label', label);
            console.log('value', value);
            console.log('percentage', percentage);
            console.log('');
            return value;
          }
        },
        */
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                value: {
                  show: true,
                  formatter(value) {
                    console.log(value);
                    return number2fileSize(value);
                  }
                },
                total: {
                  show: true,
                  label: 'Totale',
                  formatter: function (w) {
                    const sum = w.globals.seriesTotals.reduce((a, b) => {
                      return a + b
                    }, 0);
                    return number2fileSize(sum);
                  }
                }
              }
            }
          }
        }
      };
    },

    getStoreChartSeries(store) {
      return [
        store.used, store.available
      ];
    }
  }
};
</script>
